import { Inject, Injectable } from '@angular/core';

import { InjectionToken } from '@angular/core';
import { environment } from "@env/environment";
import { NewRelicMetricModel, Reservation } from "@models/micro";
import { Reservation as ReservationOld } from "@models/reservation.model";
import { NewRelicParmsInt } from "@app/interfaces/ga4.interface";
import { CussService } from "@services/cuss.service";
import { QuantumMetricService } from '@services/quantum-metric.service';

export const WINDOW = new InjectionToken<Window>('Global window object', {
  factory: () => window
});
@Injectable({
  providedIn: 'root'
})
export class NewRelicService {
  private newRelic;
  private NAME_MERTIC = environment.isAM ? "KIOSK_AM" : "KIOSK_CUSS";
  kioskID:string = '';
  constructor(
    @Inject(WINDOW) private window: Window,
    private _cussServ: CussService,
    private _quantumMetricService: QuantumMetricService
  ) {
    this.newRelic = this.window['newrelic']
  }

 /**
   * Envía una métrica a New Relic con información de la sesión actual.
   * @param {NewRelicParmsInt} data - Datos de la métrica a enviar.
   */

  sendMetric(data: NewRelicParmsInt) {
    try {
      setTimeout(() => {
        const kioskID = this.kioskID;
        const reservation = this.getReservation();
        const metric = new NewRelicMetricModel().build({
          ...data,
          reservation,
          kioskID,
          QMReplayLinkKiosk: this._quantumMetricService?.getReplayLink() || '',
        });
        this.newRelic.addPageAction(this.NAME_MERTIC, metric);
      }, 0)
    }
    catch (error) {
    }
  }

 /**
   * Obtiene la reserva almacenada en la sesión actual.
   * @returns {Reservation | undefined} - Objeto de reserva o `undefined` si no hay datos.
   */
  
  getReservation(): Reservation {
    let sessionReservation = sessionStorage.getItem('reservation');
    let reservation = new Reservation();
    if (sessionReservation) {
      sessionReservation = JSON.parse(sessionReservation);
      Object.assign(reservation, sessionReservation);
    }
    return sessionReservation ? reservation : undefined;
  }

  /**
   * Envía una métrica a New Relic utilizando un modelo de datos monolítico.
   * @param {NewRelicParmsInt} data - Datos de la métrica a enviar.
   */

  sendMetricMonolite(data: NewRelicParmsInt) {
    try {
      setTimeout(() => {
        const reservationM = this.getReservationMonolite();
        const kioskID = this._cussServ.KioskID
        const reservation = this.getReservation();
        if (reservationM) {
          reservationM.legRegion = reservation?.flightSummary?.legRegion
          const metric = new NewRelicMetricModel().buldMonolite({
            ...data,
            reservationM,
            kioskID,
            QMReplayLinkKiosk: this._quantumMetricService?.getReplayLink() || '',
          });
          this.newRelic.addPageAction(this.NAME_MERTIC, metric);
        }
      }, 0)
    }
    catch (error) {
    }
  }

 /**
   * Obtiene la reserva antigua almacenada en la sesión actual.
   * @returns {ReservationOld | undefined} - Objeto de reserva antigua o `undefined` si no hay datos.
   */
  
  getReservationMonolite(): ReservationOld {
    let sessionReservation = sessionStorage.getItem('reservationOld');
    let reservation = new ReservationOld();
    if (sessionReservation) {
      sessionReservation = JSON.parse(sessionReservation);
      Object.assign(reservation, sessionReservation);
    }
    return sessionReservation ? reservation : undefined;
  }

}
